import '../assets/NcAppNavigationNew-Ba3wWpcY.css';
import { N as NcButton } from "./NcButton-yN4vYgXb.mjs";
import { resolveComponent, createElementBlock, openBlock, createVNode, withCtx, createTextVNode, toDisplayString, renderSlot } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _sfc_main = {
  components: {
    NcButton
  },
  props: {
    buttonId: {
      type: String,
      required: false,
      default: ""
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    text: {
      type: String,
      required: true
    },
    /**
     * The color variant to use.
     * @default 'primary'
     */
    variant: {
      type: String,
      default: "primary",
      validator(value) {
        return ["primary", "secondary", "tertiary"].indexOf(value) !== -1;
      }
    }
  },
  emits: ["click"]
};
const _hoisted_1 = { class: "app-navigation-new" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NcButton = resolveComponent("NcButton");
  return openBlock(), createElementBlock("div", _hoisted_1, [
    createVNode(_component_NcButton, {
      id: $props.buttonId,
      disabled: $props.disabled,
      variant: $props.variant,
      onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click"))
    }, {
      icon: withCtx(() => [
        renderSlot(_ctx.$slots, "icon", {}, void 0, true)
      ]),
      default: withCtx(() => [
        createTextVNode(" " + toDisplayString($props.text), 1)
      ]),
      _: 3
    }, 8, ["id", "disabled", "variant"])
  ]);
}
const NcAppNavigationNew = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-08119e68"]]);
export {
  NcAppNavigationNew as N
};
//# sourceMappingURL=NcAppNavigationNew-CMjaAY5A.mjs.map
